import * as angular from 'angular';

angular.module('virtual-try-on-manager')
    .run(StyleService => StyleService.init())
    .service('StyleService', function () {
        this.init = () => {
            return import('./default.scss');
        };
    });
